document.addEventListener('DOMContentLoaded', () => {
	// Use event delegation to handle clicks and keyboard events on any copy button
	document.addEventListener('click', handleCopyButtonInteraction);
	document.addEventListener('keydown', (event) => {
		// Handle Enter or Space key
		if (event.target.closest('[data-copy-to-clipboard]') && (event.which === 13 || event.which === 32)) {
			event.preventDefault();
			handleCopyButtonInteraction(event);
		}
	});

	function handleCopyButtonInteraction(event) {
		// Find the clicked element or its closest ancestor with data-copy-to-clipboard attribute
		const button = event.target.closest('[data-copy-to-clipboard]');

		// If no matching element was found, return early
		if (!button) {
			return;
		}

		// Get the ID of element to copy from
		const sourceId = button.getAttribute('data-copy-to-clipboard');

		// Find the source element
		const sourceElement = document.getElementById(sourceId);

		if (!sourceElement) {
			return;
		}

		// Get the text content or value depending on element type
		const textToCopy = sourceElement instanceof HTMLInputElement
			? sourceElement.value.trim()
			: sourceElement.textContent.trim();

		// Store the original content and attributes
		const originalContent = button.innerHTML;
		const originalAriaLabel = button.getAttribute('aria-label');
		const originalDisabled = button.disabled;

		// Add the copied class to trigger animation
		button.classList.add('copied');

		// Update button content and attributes for success state
		button.innerHTML = '<span class="copied-text" aria-live="polite" role="status">✓<span class="screen-reader-text"> Copied to clipboard</span></span>';
		button.setAttribute('aria-label', 'Copied to clipboard');
		button.disabled = true;
		button.setAttribute('aria-disabled', 'true');

		// Create visual feedback element
		const feedbackElement = document.createElement('span');
		feedbackElement.className = 'sc-copy-success-indicator';
		feedbackElement.setAttribute('aria-hidden', 'true');
		feedbackElement.textContent = '✓ Copied';

		// Position the feedback element
		const buttonRect = button.getBoundingClientRect();
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

		feedbackElement.style.cssText = `
			position: absolute;
			background: #00a32a;
			color: white;
			padding: 3px 8px;
			border-radius: 3px;
			font-size: 12px;
			z-index: 100;
			top: ${buttonRect.top + scrollTop - 30}px;
			left: ${buttonRect.left + scrollLeft}px;
		`;

		// Add feedback element to body
		document.body.appendChild(feedbackElement);

		// Copy to clipboard using modern API with fallback
		const copyToClipboard = async () => {
			try {
				if (navigator.clipboard && navigator.clipboard.writeText) {
					await navigator.clipboard.writeText(textToCopy);
				} else {
					// Fallback for browsers that don't support the Clipboard API
					const textarea = document.createElement('textarea');
					textarea.value = textToCopy;
					textarea.setAttribute('readonly', '');
					textarea.style.position = 'absolute';
					textarea.style.left = '-9999px';
					document.body.appendChild(textarea);
					textarea.select();
					document.execCommand('copy');
					document.body.removeChild(textarea);
				}

				// Reset after animation
				setTimeout(() => {
					button.classList.remove('copied');
					button.innerHTML = originalContent;
					button.setAttribute('aria-label', originalAriaLabel || '');
					button.disabled = originalDisabled;
					button.removeAttribute('aria-disabled');

					// Remove visual feedback
					feedbackElement.remove();
				}, 1500);
			} catch (err) {
				console.error('Failed to copy text: ', err);
				// Reset on error
				button.classList.remove('copied');
				button.innerHTML = originalContent;
				button.setAttribute('aria-label', originalAriaLabel || '');
				button.disabled = originalDisabled;
				button.removeAttribute('aria-disabled');
				feedbackElement.remove();
			}
		};

		copyToClipboard();
	}
});
